import { VariantIdObject } from '@portal/config/base';

export const includesVariant = (variantToCheck: string, variants: VariantIdObject) => {
  return Boolean(
    variantToCheck.includes(variants.default) ||
      (variants.freeShipping && variantToCheck.includes(variants.freeShipping)) ||
      (variants.tropical && variantToCheck.includes(variants.tropical)) ||
      (variants.berry && variantToCheck.includes(variants.berry)) ||
      (variants.citrus && variantToCheck.includes(variants.citrus))
  );
};
